
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import ProcessPage from "../pages/process/page";
import PortfolioPage from "../pages/portfolio/page";
import IndustriesPage from "../pages/industries/page";
import PartnershipPage from "../pages/partnership/page";
import PrivacyPolicyPage from "../pages/privacy-policy/page";
import TermsOfServicePage from "../pages/terms-of-service/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/process",
    element: <ProcessPage />,
  },
  {
    path: "/portfolio",
    element: <PortfolioPage />,
  },
  {
    path: "/industries",
    element: <IndustriesPage />,
  },
  {
    path: "/partnership",
    element: <PartnershipPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
